export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/website_content.2a7d7d0.svg";